import * as types from './constants';

export default {

    // Set homepage slides
  	[types.GET_HOMEPAGE_SLIDE](state, data) {
		state.homeSlides = data;
	}
}